import http from '@/util/http-common'

class DeviceGroupsDataService {
  // List all groups
  getAll() {
    return http.get('/device-groups')
  }

  // Get a single group
  get(groupId) {
    return http.get(`/device-groups/${groupId}`)
  }

  // Create a new group
  create(data) {
    return http.post('/device-groups', data)
  }

  // Update group name / description
  update(groupId, data) {
    return http.put(`/device-groups/${groupId}`, data)
  }

  // Replace group members
  updateMembers(groupId, data) {
    return http.put(`/device-groups/${groupId}/members`, data)
  }

  // Delete a group
  delete(groupId) {
    return http.delete(`/device-groups/${groupId}`)
  }

  // Send a command to all devices in group
  sendCommand(groupId, data) {
    return http.post(`/device-groups/${groupId}/commands`, data)
  }

  // Get command history
  getCommandHistory(groupId, params = {}) {
    return http.get(`/device-groups/${groupId}/commands`, { params })
  }

  // Get the command catalog: types, per-command payload fields, option sources
  getCommandTypes() {
    return http.get('/device-groups/command-types')
  }

  // Fetch one option source for a schema-driven payload field. `path` is the
  // catalog's url with its /api prefix already stripped.
  getCommandOptions(path) {
    return http.get(path)
  }
}

export default new DeviceGroupsDataService()
